import { useCallback, useMemo } from 'react';

import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { ROUTES } from '@/shared/routes';
import { removeUserToken } from '@/shared/services/user-hash';
import { useAppSelector } from '@/store';

const getProfileInitial = (firstName?: string): string => {
  if (!firstName?.trim()) {
    return '•';
  }

  return firstName.trim().charAt(0).toUpperCase();
};

const useHeaderUserMenu = () => {
  const { navigate } = useAppNavigate();
  const { dashboardData } = useAppSelector((state) => state.leasing);

  const userName = [
    dashboardData?.profile.firstName,
    dashboardData?.profile.middleName,
    dashboardData?.profile.lastName
  ]
    .filter(Boolean)
    .join(' ');

  const profileInitial = getProfileInitial(dashboardData?.profile.firstName);

  const handleLogout = useCallback(() => {
    removeUserToken();
    navigate(ROUTES.login);
  }, [navigate]);

  return useMemo(
    () => ({
      userName,
      profileInitial,
      handleLogout
    }),
    [userName, profileInitial, handleLogout]
  );
};

export default useHeaderUserMenu;
